// The market key drives notarial FEATURE selection in the signing app — jurat and
// acknowledgement verbiage, selfie capture — via `FEATURES[market][feature]` in
// app/src/services/NotarySession.js. Two consequences make this list load-bearing:
//
//   1. `setMarket` falls back to DEFAULT_MARKET ('texas') when the field is unset,
//      so an official onboarded without a market silently notarizes with TEXAS
//      verbiage regardless of where they are actually commissioned.
//   2. `isFeatureEnabled` indexes FEATURES unguarded, so a value that isn't a key
//      of that map is a runtime TypeError in the signing app, not a soft fallback.
//
// These VALUES must therefore stay character-identical to the MARKETS keys in
// app/src/constants/features.js (notary-web-ci-cd). `market` is the non-spaced
// lookup key; the separate free-text `state` field is the display name used in
// template files, and the two are not interchangeable.
export interface MarketOption {
  value: string;
  label: string;
}

export const MARKET_OPTIONS: MarketOption[] = [
  { value: "texas", label: "Texas" },
  { value: "missouri", label: "Missouri" },
  { value: "florida", label: "Florida" },
  { value: "montana", label: "Montana" },
  { value: "louisiana", label: "Louisiana" },
  { value: "minnesota", label: "Minnesota" },
  { value: "pennsylvania", label: "Pennsylvania" },
  { value: "newyork", label: "New York" },
  { value: "newyork_biometric", label: "New York (Biometric)" },
  { value: "colorado", label: "Colorado" },
  { value: "newjersey", label: "New Jersey" },
  { value: "wisconsin", label: "Wisconsin" },
  { value: "utah", label: "Utah" },
  { value: "arizona", label: "Arizona" },
  { value: "oregon", label: "Oregon" },
  { value: "newhampshire", label: "New Hampshire" },
  { value: "illinois", label: "Illinois" },
  { value: "newmexico", label: "New Mexico" },
  { value: "wyoming", label: "Wyoming" },
];

// Convenience pre-selection only: picking a market suggests its usual zone so the
// common case is one click. It is NOT authoritative — Texas, Florida, Oregon and
// others span two zones — so the timezone field stays independently editable and
// is what actually gets persisted.
export const MARKET_DEFAULT_TIMEZONE: { [market: string]: string } = {
  texas: "America/Chicago",
  missouri: "America/Chicago",
  florida: "America/New_York",
  montana: "America/Denver",
  louisiana: "America/Chicago",
  minnesota: "America/Chicago",
  pennsylvania: "America/New_York",
  newyork: "America/New_York",
  newyork_biometric: "America/New_York",
  colorado: "America/Denver",
  newjersey: "America/New_York",
  wisconsin: "America/Chicago",
  utah: "America/Denver",
  arizona: "America/Phoenix",
  oregon: "America/Los_Angeles",
  newhampshire: "America/New_York",
  illinois: "America/Chicago",
  newmexico: "America/Denver",
  wyoming: "America/Denver",
};
